import React, { useContext, useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import GridViewIcon from '@mui/icons-material/GridView';
import { IconButton, LinearProgress, Tooltip } from '@mui/material';
import Grid from '@mui/material/Grid2';
import logo from '../assets/nplogo.jpg';
import axios from 'axios';
import LogoutIcon from '@mui/icons-material/Logout';
import {
  fetchData,
  getDataFromApi1,
  getDataFromApi2,
  getDataFromApi3,
  getDataFromApi4,
  getDataFromApi5,
} from '../api/index';
import SignInPage from './SingIn';
import { AuthContext } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
export default function Homepage() {
  const [loading, setLoading] = useState(false);
  const [data1, setData1] = useState(null);
  const [data2, setData2] = useState(null);
  const [data3, setData3] = useState(null);
  const [data4, setData4] = useState(null);
  const [data5, setData5] = useState(null);
  const [data6, setData6] = useState(null);
  const [data7, setData7] = useState(null);
  const [data8, setData8] = useState(null);
  const [fl, setFl] = useState(null);
  const [tx, setTx] = useState(null);
  const [sc, setSc] = useState(null);
  const [al, setAl] = useState(null);
  const [oh, setOh] = useState(null);
  const [ok, setOk] = useState(null);
  const [ms, setMs] = useState(null);
  const [mo, setMo] = useState(null);
  const [az, setAz] = useState(null);
  const [de, setDe] = useState(null);
  const [il, setIl] = useState(null);
  const [inn, setInn] = useState(null);
  const [ia, setIa] = useState(null);
  const [tn, setTn] = useState(null);
  const [nh, setNh] = useState(null);
  const [wv, setWv] = useState(null);
  const [wi, setWi] = useState(null);
  const [mt, setMt] = useState(null);
  const [ks, setKs] = useState(null);
  const [mi, setMi] = useState(null);
  const [la, setLa] = useState(null);
  const [ne, setNe] = useState(null);
  const [ut, setUt] = useState(null);
  const [carlGold, setCarlGold] = useState(null);
  const [carlBlue, setCarlBlue] = useState(null);
  const [shirly, setShirly] = useState(null);
  const [english, setEnglish] = useState(null);
  const [spanish, setSpanish] = useState(null);
  // Different tokens for each API request (null means no token)
  const tokens = [
    process.env.REACT_APP_API_TOKEN_1,
    null,
    null,
    null,
    process.env.REACT_APP_API_TOKEN_5,
    process.env.REACT_APP_API_TOKEN_6,
    process.env.REACT_APP_API_TOKEN_7,
    process.env.REACT_APP_API_TOKEN_8,
    process.env.REACT_APP_API_TOKEN_9,
  ];

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);

      try {
        // Fetch data from API
        const [
          d1,
          d2,
          d3,
          d4,
          d5,
          d6,
          d7,
          d8,
          fl,
          tx,
          sc,
          al,
          oh,
          ok,
          ms,
          inn,
          mo,
          az,
          de,
          il,
          ia,
          tn,
          nh,
          wv,
          wi,
          mt,
          ks,
          mi,
          la,
          ne,
          ut,
          carlGold,
          carlBlue,
          shirly,
          english,
          spanish,
        ] = await fetchData(tokens);

        // Store data in separate state variables
        setData1(d1);
        setData2(d2);
        setData3(d3);
        setData4(d4);
        setData5(d5);
        setData6(d6);
        setData7(d7);
        setData8(d8);
        setFl(fl);
        setTx(tx);
        setSc(sc);
        setAl(al);
        setOh(oh);
        setOk(ok);
        setMs(ms);
        setMo(mo);
        setAz(az);
        setDe(de);
        setIl(il);
        setInn(inn);
        setIa(ia);
        setTn(tn);
        setNh(nh);
        setWv(wv);
        setWi(wi);
        setMt(mt);
        setKs(ks);
        setMi(mi);
        setLa(la);
        setNe(ne);
        setUt(ut);
        setCarlGold(carlGold);
        setCarlBlue(carlBlue);
        setShirly(shirly);
        setEnglish(english);
        setSpanish(spanish);
        console.log('data', d1);
        console.log('data', d2);
        console.log('data', d3);
        console.log('data', d4);
      } catch (error) {
        console.error('Failed to fetch data');
      } finally {
        setLoading(false);
      }
    };

    // Initial fetch
    loadData();

    // Set interval to refresh every 5 seconds
    const interval = setInterval(loadData, 5000);

    // Cleanup interval when component unmounts
    return () => clearInterval(interval);
  }, []); // Re-run if tokens change
  const { dispatch } = useContext(AuthContext);
  const navigate = useNavigate();
  useEffect(() => {
    const loginTimestamp = localStorage.getItem('loginTimestamp');

    if (loginTimestamp) {
      const currentTime = new Date().getTime();
      const sevenDaysInMs = 7 * 24 * 60 * 60 * 1000;

      if (currentTime - loginTimestamp > sevenDaysInMs) {
        handleLogout(); // Expired, auto-logout
      }
    }
  }, []);
  const handleLogout = () => {
    dispatch({ type: 'LOGOUT' });
    localStorage.removeItem('loginTimestamp');

    navigate('/');
  };
  console.log('data', data1);
  console.log('data', data2);
  console.log('data', data3);
  console.log('data', data4);
  console.log('data', data5);
  console.log('data', data6);
  console.log('data', data7);
  console.log('data', data8);
  return (
    <div className="home-container">
      <div className="loding-container">{loading && <LinearProgress />}</div>
      <div className="nav-container">
        <div className="nav-right">
          <img src={logo} alt="" />
          <h1>RTB Agent Status </h1>
        </div>
        <div className="logo-nav">
          <Tooltip title="Logout">
            <IconButton aria-label="Log out" onClick={handleLogout}>
              <LogoutIcon />
            </IconButton>
          </Tooltip>
        </div>
      </div>
      <div className="main-container">
        {/* <div className="left-container">
          <div className="menu-item">
            <GridViewIcon /> Dashboard
          </div>
        </div> */}
        <div className="right-container">
          <Grid container spacing={3}>
            {/* <Grid item size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
              <Paper
                elevation={3}
                sx={{
                  padding: '20px',
                  color: '#558fca',
                  height: '180px',
                }}
              >
                <div className="card-header">GREEN-SW (Phase 1)</div>
                <div className="card-title">
                  <span>GREEN-SW (Phase 1):</span>{' '}
                  <span className={data1?.count > 0 ? 'counter' : 'counter2'}>
                    {data1?.count || 0}
                  </span>{' '}
                  agents
                </div>
                <div className="card-description">
                  <span>States: </span> AS, AL, EF, FA, FL, KS, MI, MS, MT, SC,
                  TN, TX, UT
                </div>
              </Paper>
            </Grid> */}
            {/* <Grid item size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
              <Paper
                elevation={3}
                sx={{
                  padding: '20px',
                  color: '#558fca',
                  height: '180px',
                }}
              >
                <div className="card-header">Ben</div>
                <div className="card-title">
                  <span>Ben:</span>{' '}
                  <span
                    className={
                      data2?.ready && parseInt(data2?.ready) > 0
                        ? 'counter'
                        : 'counter2'
                    }
                  >
                    {(data2?.ready && parseInt(data2?.ready)) || 0}
                  </span>{' '}
                  agents
                </div>
                <div className="card-description">
                  <span>States: </span> AS, AL, EF, FA, FL, KS, MI, MS, MT, SC,
                  TN, TX, UT
                </div>
              </Paper>
            </Grid> */}
            {/* <Grid item size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
              <Paper
                elevation={3}
                sx={{
                  padding: '20px',
                  color: '#558fca',
                  height: '180px',
                }}
              >
                <div className="card-header">Cozmo health: Live Transfers</div>
                <div className="card-title">
                  <span>Live Transfers:</span>{' '}
                  <span
                    className={
                      data3?.count && parseInt(data3?.count) > 0
                        ? 'counter'
                        : 'counter2'
                    }
                  >
                    {data3?.count || 0}
                  </span>{' '}
                  agents
                </div>
                <div className="card-description">
                  <span>States: </span> AS, AL, EF, FA, FL, KS, MI, MS, MT, SC,
                  TN, TX, UT
                </div>
              </Paper>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
              <Paper
                elevation={3}
                sx={{
                  padding: '20px',
                  color: '#558fca',
                  height: '180px',
                }}
              >
                <div className="card-header">Cozmo health: Inbounds </div>
                <div className="card-title">
                  <span>Inbounds:</span>{' '}
                  <span
                    className={
                      data4?.count && parseInt(data4?.count) > 0
                        ? 'counter'
                        : 'counter2'
                    }
                  >
                    {data4?.count || 0}
                  </span>{' '}
                  agents
                </div>
                <div className="card-description">
                  <span>States: </span> AS, AL, EF, FA, FL, KS, MI, MS, MT, SC,
                  TN, TX, UT
                </div>
              </Paper>
            </Grid> */}
            <Grid item size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
              <Paper
                elevation={3}
                sx={{
                  padding: '20px',
                  color: '#558fca',
                  height: '180px',
                }}
              >
                <div className="card-header">Go</div>

                <div className="section-state">
                  <div>States:</div>
                  <div className="states-holder">
                    <div>
                      <span>FL</span>:{' '}
                      <span
                        className={
                          fl?.count && parseInt(fl?.count) > 0
                            ? 'counterstate'
                            : ''
                        }
                      >
                        {fl?.count || 0}
                      </span>
                    </div>
                    <div>
                      <span>TX</span>:{' '}
                      <span
                        className={
                          tx?.count && parseInt(tx?.count) > 0
                            ? 'counterstate'
                            : ''
                        }
                      >
                        {tx?.count || 0}
                      </span>
                    </div>
                    <div>
                      <span>SC</span>:{' '}
                      <span
                        className={
                          sc?.count && parseInt(sc?.count) > 0
                            ? 'counterstate'
                            : ''
                        }
                      >
                        {sc?.count || 0}
                      </span>
                    </div>
                    <div>
                      <span>AL</span>:{' '}
                      <span
                        className={
                          al?.count && parseInt(al?.count) > 0
                            ? 'counterstate'
                            : ''
                        }
                      >
                        {al?.count || 0}
                      </span>
                    </div>
                    <div>
                      <span>OH</span>:{' '}
                      <span
                        className={
                          oh?.count && parseInt(oh?.count) > 0
                            ? 'counterstate'
                            : ''
                        }
                      >
                        {oh?.count || 0}
                      </span>
                    </div>
                    <div>
                      <span>OK</span>:{' '}
                      <span
                        className={
                          ok?.count && parseInt(ok?.count) > 0
                            ? 'counterstate'
                            : ''
                        }
                      >
                        {ok?.count || 0}
                      </span>
                    </div>
                    <div>
                      <span>MS</span>:{' '}
                      <span
                        className={
                          ms?.count && parseInt(ms?.count) > 0
                            ? 'counterstate'
                            : ''
                        }
                      >
                        {ms?.count || 0}
                      </span>
                    </div>
                    <div>
                      <span>MO</span>:{' '}
                      <span
                        className={
                          mo?.count && parseInt(mo?.count) > 0
                            ? 'counterstate'
                            : ''
                        }
                      >
                        {mo?.count || 0}
                      </span>
                    </div>
                    <div>
                      <span>AZ</span>:{' '}
                      <span
                        className={
                          az?.count && parseInt(az?.count) > 0
                            ? 'counterstate'
                            : ''
                        }
                      >
                        {az?.count || 0}
                      </span>
                    </div>
                    <div>
                      <span>DE</span>:{' '}
                      <span
                        className={
                          de?.count && parseInt(de?.count) > 0
                            ? 'counterstate'
                            : ''
                        }
                      >
                        {de?.count || 0}
                      </span>
                    </div>
                    <div>
                      <span>IL</span>:{' '}
                      <span
                        className={
                          il?.count && parseInt(il?.count) > 0
                            ? 'counterstate'
                            : ''
                        }
                      >
                        {il?.count || 0}
                      </span>
                    </div>
                    <div>
                      <span>IN</span>:{' '}
                      <span
                        className={
                          inn?.count && parseInt(inn?.count) > 0
                            ? 'counterstate'
                            : ''
                        }
                      >
                        {inn?.count || 0}
                      </span>
                    </div>
                    <div>
                      <span>IA</span>:{' '}
                      <span
                        className={
                          ia?.count && parseInt(ia?.count) > 0
                            ? 'counterstate'
                            : ''
                        }
                      >
                        {ia?.count || 0}
                      </span>
                    </div>
                    <div>
                      <span>TN</span>:{' '}
                      <span
                        className={
                          tn?.count && parseInt(tn?.count) > 0
                            ? 'counterstate'
                            : ''
                        }
                      >
                        {tn?.count || 0}
                      </span>
                    </div>
                    <div>
                      <span>NH</span>:{' '}
                      <span
                        className={
                          nh?.count && parseInt(nh?.count) > 0
                            ? 'counterstate'
                            : ''
                        }
                      >
                        {nh?.count || 0}
                      </span>
                    </div>
                    <div>
                      <span>WV</span>:{' '}
                      <span
                        className={
                          wv?.count && parseInt(wv?.count) > 0
                            ? 'counterstate'
                            : ''
                        }
                      >
                        {wv?.count || 0}
                      </span>
                    </div>
                    <div>
                      <span>WI</span>:{' '}
                      <span
                        className={
                          wi?.count && parseInt(wi?.count) > 0
                            ? 'counterstate'
                            : ''
                        }
                      >
                        {wi?.count || 0}
                      </span>
                    </div>
                    <div>
                      <span>MT</span>:{' '}
                      <span
                        className={
                          mt?.count && parseInt(mt?.count) > 0
                            ? 'counterstate'
                            : ''
                        }
                      >
                        {mt?.count || 0}
                      </span>
                    </div>
                    <div>
                      <span>KS</span>:{' '}
                      <span
                        className={
                          ks?.count && parseInt(ks?.count) > 0
                            ? 'counterstate'
                            : ''
                        }
                      >
                        {ks?.count || 0}
                      </span>
                    </div>
                    <div>
                      <span>MI</span>:{' '}
                      <span
                        className={
                          mi?.count && parseInt(mi?.count) > 0
                            ? 'counterstate'
                            : ''
                        }
                      >
                        {mi?.count || 0}
                      </span>
                    </div>
                    <div>
                      <span>LA</span>:{' '}
                      <span
                        className={
                          la?.count && parseInt(la?.count) > 0
                            ? 'counterstate'
                            : ''
                        }
                      >
                        {la?.count || 0}
                      </span>
                    </div>
                    <div>
                      <span>NE</span>:{' '}
                      <span
                        className={
                          ne?.count && parseInt(ne?.count) > 0
                            ? 'counterstate'
                            : ''
                        }
                      >
                        {ne?.count || 0}
                      </span>
                    </div>
                    <div>
                      <span>UT</span>:{' '}
                      <span
                        className={
                          ut?.count && parseInt(ut?.count) > 0
                            ? 'counterstate'
                            : ''
                        }
                      >
                        {ut?.count || 0}
                      </span>
                    </div>
                  </div>
                </div>
              </Paper>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
              <Paper
                elevation={3}
                sx={{
                  padding: '20px',
                  color: '#558fca',
                  height: '180px',
                }}
              >
                <div className="card-header">SeniorMed</div>
                <div className="card-title">
                  <span>SeniorMed:</span>{' '}
                  <span
                    className={
                      data5?.count && parseInt(data5?.count) > 0
                        ? 'counter'
                        : 'counter2'
                    }
                  >
                    {data5?.count || 0}
                  </span>{' '}
                  agents
                </div>
                <div className="card-description">
                  <span>States: </span> AS, AL, EF, FA, FL, KS, MI, MS, MT, SC,
                  TN, TX, UT
                </div>
              </Paper>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
              <Paper
                elevation={3}
                sx={{
                  padding: '20px',
                  color: '#558fca',
                  height: '180px',
                }}
              >
                <div className="card-header">GREEN-SW</div>
                <div className="card-title">
                  <span>GREEN-SW:</span>{' '}
                  <span
                    className={
                      data6?.count && parseInt(data6?.count)
                        ? 'counter'
                        : 'counter2'
                    }
                  >
                    {data6?.count || 0}
                  </span>{' '}
                  agents
                </div>
                <div className="card-description">
                  <span>States: </span> AS, AL, EF, FA, FL, KS, MI, MS, MT, SC,
                  TN, TX, UT
                </div>
              </Paper>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
              <Paper
                elevation={3}
                sx={{
                  padding: '20px',
                  color: '#558fca',
                  height: '180px',
                }}
              >
                <div className="card-header">Green Morning</div>
                <div className="card-title">
                  <span>Green Morning:</span>{' '}
                  <span
                    className={
                      data7?.count && parseInt(data7?.count)
                        ? 'counter'
                        : 'counter2'
                    }
                  >
                    {data7?.count || 0}
                  </span>{' '}
                  agents
                </div>
                <div className="card-description">
                  <span>States: </span> AS, AL, EF, FA, FL, KS, MI, MS, MT, SC,
                  TN, TX, UT
                </div>
              </Paper>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
              <Paper
                elevation={3}
                sx={{
                  padding: '20px',
                  color: '#558fca',
                  height: '180px',
                }}
              >
                <div className="card-header">GREEN-RAD</div>
                <div className="card-title">
                  <span>GREEN-RAD:</span>{' '}
                  <span
                    className={
                      data8?.count && parseInt(data8?.count)
                        ? 'counter'
                        : 'counter2'
                    }
                  >
                    {data8?.count || 0}
                  </span>{' '}
                  agents
                </div>
                <div className="card-description">
                  <span>States: </span> AS, AL, EF, FA, FL, KS, MI, MS, MT, SC,
                  TN, TX, UT
                </div>
              </Paper>
            </Grid>{' '}
            <Grid item size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
              <Paper
                elevation={3}
                sx={{
                  padding: '20px',
                  color: '#558fca',
                  height: '180px',
                }}
              >
                <div className="card-header">Carl Gold</div>
                <div className="card-title">
                  <span>Carl Gold:</span>{' '}
                  <span
                    className={
                      carlGold?.availableAgents &&
                      parseInt(carlGold?.availableAgents)
                        ? 'counter'
                        : 'counter2'
                    }
                  >
                    {carlGold?.availableAgents || 0}
                  </span>{' '}
                  agents
                </div>
                <div className="card-description">
                  <span>States: </span> AS, AL, EF, FA, FL, KS, MI, MS, MT, SC,
                  TN, TX, UT
                </div>
              </Paper>
            </Grid>{' '}
            <Grid item size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
              <Paper
                elevation={3}
                sx={{
                  padding: '20px',
                  color: '#558fca',
                  height: '180px',
                }}
              >
                <div className="card-header">Carl Blue</div>
                <div className="card-title">
                  <span>Carl Blue:</span>{' '}
                  <span
                    className={
                      carlBlue?.availableAgents &&
                      parseInt(carlBlue?.availableAgents)
                        ? 'counter'
                        : 'counter2'
                    }
                  >
                    {carlBlue?.availableAgents || 0}
                  </span>{' '}
                  agents
                </div>
                <div className="card-description">
                  <span>States: </span> AS, AL, EF, FA, FL, KS, MI, MS, MT, SC,
                  TN, TX, UT
                </div>
              </Paper>
            </Grid>{' '}
            <Grid item size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
              <Paper
                elevation={3}
                sx={{
                  padding: '20px',
                  color: '#558fca',
                  height: '180px',
                }}
              >
                <div className="card-header">shirly cpa aca</div>
                <div className="card-title">
                  <span>Shirly cpa aca:</span>{' '}
                  <span
                    className={
                      shirly?.availableAgents &&
                      parseInt(shirly?.availableAgents)
                        ? 'counter'
                        : 'counter2'
                    }
                  >
                    {shirly?.availableAgents || 0}
                  </span>{' '}
                  agents
                </div>
                <div className="card-description">
                  <span>States: </span> AS, AL, EF, FA, FL, KS, MI, MS, MT, SC,
                  TN, TX, UT
                </div>
              </Paper>
            </Grid>{' '}
            <Grid item size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
              <Paper
                elevation={3}
                sx={{
                  padding: '20px',
                  color: '#558fca',
                  height: '180px',
                }}
              >
                <div className="card-header">English</div>
                <div className="card-title">
                  <span>English:</span>{' '}
                  <span
                    className={
                      english?.ready && parseInt(english?.ready)
                        ? 'counter'
                        : 'counter2'
                    }
                  >
                    {english?.ready || 0}
                  </span>{' '}
                  agents
                </div>
                <div className="card-description">
                  <span>States: </span> AL, AZ, FL, GA, IA, IL, IN, KS, LA, MI,
                  MS, MO, NE, OH, OK, SC, TN, TX, WI
                </div>
              </Paper>
            </Grid>{' '}
            <Grid item size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
              <Paper
                elevation={3}
                sx={{
                  padding: '20px',
                  color: '#558fca',
                  height: '180px',
                }}
              >
                <div className="card-header">Spanish</div>
                <div className="card-title">
                  <span>Spanish:</span>{' '}
                  <span
                    className={
                      spanish?.ready && parseInt(spanish?.ready)
                        ? 'counter'
                        : 'counter2'
                    }
                  >
                    {spanish?.ready || 0}
                  </span>{' '}
                  agents
                </div>
                <div className="card-description">
                  <span>States: </span> AL, AZ, FL, GA, IA, IL, IN, KS, LA, MI,
                  MS, MO, NE, OH, OK, SC, TN, TX, WI
                </div>
              </Paper>
            </Grid>{' '}
            <Grid item size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
              <Paper
                elevation={3}
                sx={{
                  padding: '20px',
                  color: '#558fca',
                  height: '180px',
                }}
              >
                <div className="card-header">Reporting - Orlando</div>
                <div className="card-title">
                  <span>Orlando:</span>{' '}
                  <span
                    className={
                      spanish?.ready && parseInt(spanish?.ready)
                        ? 'counter'
                        : 'counter2'
                    }
                  >
                    {spanish?.ready || 0}
                  </span>{' '}
                  agents
                </div>
                <div className="card-description">
                  <span>States: </span> AL, AZ, FL, GA, IA, IL, IN, KS, LA, MI,
                  MS, MO, NE, OH, OK, SC, TN, TX, WI
                </div>
              </Paper>
            </Grid>{' '}
            <Grid item size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
              <Paper
                elevation={3}
                sx={{
                  padding: '20px',
                  color: '#558fca',
                  height: '180px',
                }}
              >
                <div className="card-header">Reporting - Fourt Lauderdale</div>
                <div className="card-title">
                  <span>Fourt Lauderdale:</span>{' '}
                  <span
                    className={
                      spanish?.ready && parseInt(spanish?.ready)
                        ? 'counter'
                        : 'counter2'
                    }
                  >
                    {spanish?.ready || 0}
                  </span>{' '}
                  agents
                </div>
                <div className="card-description">
                  <span>States: </span> AL, AZ, FL, GA, IA, IL, IN, KS, LA, MI,
                  MS, MO, NE, OH, OK, SC, TN, TX, WI
                </div>
              </Paper>
            </Grid>{' '}
            {/* <Grid item size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
              <Paper
                elevation={3}
                sx={{
                  padding: '20px',
                  color: '#558fca',
                  height: '180px',
                }}
              >
                <div className="card-header">EZHG 1</div>
                <div className="card-title">
                  <span>EZHG 3 :</span>{' '}
                  <span className={data1?.count > 0 ? 'counter' : 'counter2'}>
                    0
                  </span>{' '}
                  agents
                </div>
                <div className="card-description">
                  <span>States: </span> AS, AL, EF, FA, FL, KS, MI, MS, MT, SC,
                  TN, TX, UT
                </div>
              </Paper>
            </Grid> */}
            {/* <Grid item size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
              <Paper
                elevation={3}
                sx={{
                  padding: '20px',
                  color: '#558fca',
                  height: '180px',
                }}
              >
                <div className="card-header">EZHG 2</div>
                <div className="card-title">
                  <span>EZHG 2 :</span>{' '}
                  <span className={data1?.count > 0 ? 'counter' : 'counter2'}>
                    0
                  </span>{' '}
                  agents
                </div>
                <div className="card-description">
                  <span>States: </span> AS, AL, EF, FA, FL, KS, MI, MS, MT, SC,
                  TN, TX, UT
                </div>
              </Paper>
            </Grid> */}
            {/* <Grid item size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
              <Paper
                elevation={3}
                sx={{
                  padding: '20px',
                  color: '#558fca',
                  height: '180px',
                }}
              >
                <div className="card-header">EZHG 3</div>
                <div className="card-title">
                  <span>EZHG 3 :</span>
                  <span className={data1?.count > 0 ? 'counter' : 'counter2'}>
                    0
                  </span>
                  agents
                </div>
                <div className="card-description">
                  <span>States: </span> AS, AL, EF, FA, FL, KS, MI, MS, MT, SC,
                  TN, TX, UT
                </div>
              </Paper>
            </Grid> */}
          </Grid>
        </div>
      </div>
    </div>
  );
}
